// ante-react-kit/src/components/AntQuickPopup/utils/resolveLookup.js

/**
 * Merge lookup từ 2 nguồn:
 *   1. BE response.lookups (per-record, ưu tiên cao)
 *   2. FE init-lookups registry (global, fallback)
 *   3. fieldsCnf[fieldName].values (định nghĩa trong config/fields/{Table}.json)
 *
 * @param {string} fieldName
 * @param {Object} args
 * @param {Object} args.lookupsBE      - response.lookups từ BE
 * @param {Array}  args.lookupsFE      - FE registry array [{name, value}]
 * @param {Object} args.fieldCnf       - field config (có thể chứa .values)
 * @returns {Array<{code, name, ...meta}>}
 */
export default function resolveLookup(fieldName, { lookupsBE, lookupsFE, fieldCnf }) {
    // 1. BE per-record (ưu tiên cao nhất)
    if (lookupsBE && Array.isArray(lookupsBE[fieldName])) {
        return lookupsBE[fieldName];
    }

    // 2. FE global registry
    if (lookupsFE) {
        const found = lookupsFE.find((l) => l.name === fieldName);
        if (found && Array.isArray(found.value)) return found.value;
    }

    // 3. fieldsCnf.values
    if (fieldCnf && Array.isArray(fieldCnf.values)) return fieldCnf.values;

    return [];
}
